import { ResponsivePie } from "@nivo/pie";

const ApiStatusPie = () => {
  const data = [
    { id: "Success", value: 96 },
    { id: "Errors", value: 3 },
    { id: "Timeout", value: 1 },
  ];

  return (
    <div className="h-[320px] bg-white rounded-2xl border border-gray-200 p-4">
      <h3 className="text-lg font-semibold mb-2">API Status</h3>

      <ResponsivePie
        data={data}
        margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
        innerRadius={0.6}
        padAngle={2}
        cornerRadius={6}
        colors={["#10b981", "#ef4444", "#f59e0b"]}
        activeOuterRadiusOffset={8}
        enableArcLinkLabels={false}
      />
    </div>
  );
};

export default ApiStatusPie;